import api from './api';

export const startQuiz = (testId) => api.post(`/quiz/${testId}/start`);
export const submitQuiz = (attemptId, answers) => api.post(`/quiz/${attemptId}/submit`, { answers });
export const getQuizAttempts = (testId) => api.get(`/quiz/${testId}/attempts`);